export default __webpack_public_path__ + "static/media/orange_circle.66489994.svg";